import React, { PureComponent } from "react";
import QuizzContext, {
  getDefaultContext,
  IQuizzContext
} from "../QuizzContext";
import TranslatedText from "../translations/TranslatedText";
import { message, Empty, Button, Form, Row, Col } from "antd";
import { pushResponseDB, getQuizName, saveResponseLocal,
         Subscribe, } from "../lib";
import './Quiz.css';
import QuizProgressBar from 'ReusableComponents/QuizProgressBar';
import CheckAnswerButton from 'ReusableComponents/CheckAnswerButton'

class Quizz extends PureComponent<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      disableNextQuizButton: true,
      nextQuizButtonStyle: "disabled",
      checkAnswer: false,
      enableSubmit: props.enableSubmit,
      enableCheckAnswer: props.enableCheckAnswer,
      enableQuizProgress: props.enableQuizProgress,
      questionComplete: false,
    }

    if (this.state.enableSubmit) {
      Subscribe.onSaveResponse(this.props.questionsIndex, () => {
        this.setState({
          disableNextQuizButton: false,
          nextQuizButtonStyle: "enabled",
        });
      });
    }
  }

  // submit handler
  handleSubmit(e: React.MouseEvent<HTMLElement, MouseEvent>) {
    e.preventDefault();
    const { onSubmit, form } = this.props;

    form.validateFields((err: any, values: any) => {
      if (!err) {
        if (typeof onSubmit === "function") {
          // sends values to parent if has onSubmit
          onSubmit(values);
          this.setCheckAnswer(false);
        }
      }
    });
  }

  onCheckAnswer(id: string, response: any, questionsKey: number) {
    if (this.state.enableSubmit) {
      saveResponseLocal(id, response, getQuizName(), questionsKey);

      const onSuccess = () => {}
      const onError = (error:any) => {
        message.error(error.toString(), 2.5);
        console.error(error, error.toString());
      }
      pushResponseDB(onSuccess, onError);
    }
  }

  setCheckAnswer(checkAnswer: boolean) {
    this.setState({ checkAnswer, questionComplete: true })
  }

  static defaultProps = {
    submitButton: true
  };

  render() {
    const { form, data, questionsKey, questionsIndex,
            submitButton, onCheckAnswer, ...rest } = this.props,
      contextValue = getDefaultContext(rest as IQuizzContext);

    return (
      <div className="quiz-composer-quiz">
        {
          this.state.enableQuizProgress && (
            <QuizProgressBar questionComplete={this.state.questionComplete}
                             questionsIndex={questionsIndex}
            />
          )
        }
        <QuizzContext.Provider value={contextValue}>
          <Form className="quiz-composer-quiz">
            <Row type="flex" justify="center" align="middle">
              <Col span={20}>
                {data.map((item: any) => {
                  const current_key = item.element;
                  // searchs for the current input on the toolbox to get the component
                  const found_toolbox_input = contextValue["toolBox"].find(
                    (toolBoxInput: any) => current_key === toolBoxInput.key
                  ) as any;
                  // finds input and wrapps it with delete and edit button
                  const Component = found_toolbox_input
                    ? found_toolbox_input.Component
                    : Empty;

                  return (
                    <Component
                      // render the toolbox component
                      key={item.id}
                      form={form}
                      toolboxData={found_toolbox_input}
                      inputData={item}
                      questionsKey={questionsKey}
                      language={contextValue["language"]}
                      onCheckAnswer={this.onCheckAnswer.bind(this)}
                      checkAnswer={this.state.checkAnswer}
                    />
                  );
                })}
              </Col>
              <Col></Col>
            </Row>
            <Row type="flex" justify="center">
              <Col>
                <br />
                {
                  this.state.enableCheckAnswer && !this.state.checkAnswer ?
                  <CheckAnswerButton checkAnswer={this.state.checkAnswer}
                                     setCheckAnswer={this.setCheckAnswer.bind(this)}
                  /> :
                  null
                }
                {
                  this.state.checkAnswer && submitButton ?
                  <Form.Item>
                    <Button
                      htmlType="submit" onClick={this.handleSubmit.bind(this)}
                      type="primary" shape="circle" icon="right" size="large"
                      className={this.state.nextQuizButtonStyle}
                      disabled={this.state.disableNextQuizButton}
                    />
                  </Form.Item> :
                  null
                }
                <br />
                <br />
              </Col>
            </Row>
          </Form>
        </QuizzContext.Provider>
      </div>
    );
  }
}

export default Form.create<any>()(Quizz);
